import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowRight, Calculator, BookOpen, ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";

const COPY = {
  demo: ["Your walkthrough request is in.", "A member of the norse3 team will review your request and reply within two working days to arrange a time."],
  briefing: ["Your briefing request is in.", "A member of the norse3 team will review your request and respond through an appropriate channel."],
  fs: ["Your walkthrough request is in.", "Our financial services team will be in touch within two working days."],
  sovereign: ["Your in-country deployment enquiry is in.", "Our sovereign deployment lead will be in touch to discuss your jurisdiction and hosting requirements."],
};

const NEXT = [
  { to: "/governance-tools", icon: ShieldCheck, t: "Run a governance assessment", d: "See where your AI controls stand today." },
  { to: "/roi-calculator", icon: Calculator, t: "Build the business case", d: "Estimate reviewer hours saved." },
  { to: "/insights", icon: BookOpen, t: "Read our insights", d: "Practical guidance on AI oversight." },
];

export default function ThankYou() {
  const [params] = useSearchParams();
  const [title, body] = COPY[params.get("type")] || COPY.demo;

  return (
    <section className="py-24 lg:py-32" data-testid="thank-you-page">
      <div className="mx-auto max-w-4xl px-5 lg:px-8">
        <CheckCircle2 className="h-12 w-12 text-signal-green" />
        <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-primary">Thank you</p>
        <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-bold text-foreground" data-testid="thank-you-title">{title}</h1>
        <p className="mt-5 text-base text-muted-foreground max-w-2xl">{body} For anything urgent, email{" "}
          <a href="mailto:info@norse3.com" className="text-primary hover:underline" data-testid="thank-you-email">info@norse3.com</a>.
        </p>
        <h2 className="mt-14 text-base md:text-lg font-semibold text-foreground">While you wait</h2>
        <div className="mt-5 grid md:grid-cols-3 gap-4">
          {NEXT.map(({ to, icon: Icon, t, d }) => (
            <Link key={to} to={to} className="card-rise group rounded-lg border border-border bg-card p-5 hover:border-primary/40 transition-colors" data-testid={`thank-you-next-${to.slice(1)}`}>
              <Icon className="h-5 w-5 text-primary" />
              <p className="mt-4 text-sm font-semibold text-foreground">{t}</p>
              <p className="mt-1 text-sm text-muted-foreground">{d}</p>
            </Link>
          ))}
        </div>
        <Button asChild variant="outline" className="mt-10" data-testid="thank-you-home-btn">
          <Link to="/">Back to home <ArrowRight className="ml-1.5 h-4 w-4" /></Link>
        </Button>
      </div>
    </section>
  );
}
